import { ReactComponent as TruckSVG } from './../TruckSVG.svg';

export default function TruckToggleButton({ showSupplier, setShowSupplier, language, t }) {
  return (
    <>
      <style>{`
        .truck-display-container-xyz {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 20px;
          margin-top: 9px;
        }

        .truck-svg-wrapper-xyz {
          position: relative;
          width: 130px;
          height: 130px;
          color: var(--color-main-background);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: color 0.3s ease;
          cursor: pointer;
        }


        .truck-svg-wrapper-xyz.license-mode-xyz {
          color: var(--color-main-background);
        }

        .truck-svg-wrapper-xyz svg {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transform: rotate(270deg);
          opacity: 0.9;
        }

        .truck-text-overlay-xyz {
          position: absolute;
          top: 51%;
          left: 64%;
          transform: translate(-50%, -50%);
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
          pointer-events: none;
          z-index: 5;
          transition: opacity 0.3s ease, color 0.3s ease;
          color: #FFFFFF;
          padding: 1px 3px;
          border-radius: 2px;
          letter-spacing: 0.3px;
        }

        .truck-text-left-overlay-xyz {
          opacity: 1;
        }

        .truck-svg-wrapper-xyz.license-mode-xyz .truck-text-left-overlay-xyz {
          opacity: 0;
        }

        .truck-text-right-overlay-xyz {
          opacity: 0;
          color:#FFFFFF;
        }

        .truck-svg-wrapper-xyz.license-mode-xyz .truck-text-right-overlay-xyz {
          opacity: 1;
        }
      `}</style>

      <div className="truck-display-container-xyz">
        <div
          className={`truck-svg-wrapper-xyz ${showSupplier ? '' : 'license-mode-xyz'}`}
          onClick={() => setShowSupplier(!showSupplier)}
          title={showSupplier ? t('yardView.showLicense', language) : t('yardView.showSupplier', language)}
        >
          <TruckSVG />
          <div className={`truck-text-overlay-xyz truck-text-left-overlay-xyz`}>
            {t('yardView.supplier', language)}
          </div>
          <div className={`truck-text-overlay-xyz truck-text-right-overlay-xyz`}>
            {t('yardView.licensePlate', language)}
          </div>
        </div>
      </div>
    </>
  );
}
// import React from 'react';

// export default function TruckToggleButton({ showSupplier, setShowSupplier, language, t }) {
//   return (
//     <>
//       <style>{`
//         .toggle-display-button {
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             flex-direction: row;
//             gap: 8px;
//             background-color: white;
//             border-radius: 32px;
//             padding: 3px 8px;
//             color: var(--color-main-background);
//             border: 2px solid var(--color-main-background);
//             outline: none;
//             font-size: 13px;
//             font-weight: 600;
//             cursor: pointer;
//             transition: all 0.2s
//         ease-in-out;
//             white-space: nowrap;
//         }

//         .toggle-display-button:hover {
//           background-color: var(--color-main-background);
//           color: white;
//         }

//         .toggle-display-button:active {
//           transform: scale(0.98);
//         }

//         .toggle-display-button i {
//           font-size: 18px;
//         }
//       `}</style>
//       <div>
//         <button
//           className="toggle-display-button"
//           onClick={() => setShowSupplier(!showSupplier)}
//           title={showSupplier ? t('yardView.showLicense', language) : t('yardView.showSupplier', language)}
//         >
//           {showSupplier ? (
//             <>
//               <i className="bi bi-building"></i>
//               {t('yardView.supplier', language)}
//             </>
//           ) : (
//             <>
//               <i className="bi bi-truck"></i>
//               {t('yardView.licensePlate', language)}
//             </>
//           )}
//         </button>
//       </div>
//     </>
//   );
// }